import { InAppPackage } from "./mailcredit";
import { LovewallSubscriptionPlan } from "./subscription";

export type PackageBundle = {
  _id: string;
  amount: number;
  createdAt: string;
  description: string;
  inAppPackageID: string;
  loveWallSubscriptionPlanID: string;
  inAppPackage: InAppPackage;
  lovewallSubscriptionPlan: LovewallSubscriptionPlan;
  name: string;
  updatedAt: string;
};

export enum PackageBundleBookingAppliedStatus {
  Applied = "APPLIED",
  NotApplied = "NOT_APPLIED",
}

export enum PackageBundleBookingOwnerContext {
  EventPlanner = "EVENT_PLANNER",
}

export type PackageBundleBooking = {
  _id: string;
  packageBundleID: string;
  accountID: string;
  weddingID: string;
  ownerID: string;
  ownerCtx: PackageBundleBookingOwnerContext;
  appliedStatus: PackageBundleBookingAppliedStatus;
  loveWallSubscriptionID: string;
  createdAt: Date;
  updatedAt: Date;
};
